import React from 'react';
import { CheckCircle, XCircle } from 'lucide-react';
import { useLocation, Link } from 'react-router-dom';

const PaymentStatus = () => {
  const location = useLocation();
  const query = new URLSearchParams(location.search);
  const transactionId = query.get('transactionId');
  const courseName = query.get('course');
  const isNewUser = query.get('newUser') === 'true';
  const isSuccess = location.pathname.toLowerCase().includes('success');

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50 p-4">
      <div className="bg-white p-8 md:p-10 text-center max-w-md shadow-2xl rounded-2xl border border-gray-100 w-full">
        <div
          className={`mx-auto w-16 h-16 ${isSuccess ? 'bg-green-100 text-green-600' : 'bg-red-100 text-red-600'
            } rounded-full flex items-center justify-center mb-6 shadow-sm`}
        >
          {isSuccess ? <CheckCircle className="w-8 h-8" /> : <XCircle className="w-8 h-8" />}
        </div>
        <h2 className="text-2xl font-bold uppercase text-gray-900 mb-2">
          {isSuccess ? 'Payment Successful' : 'Payment Failed'}
        </h2>
        <p className="font-sans text-gray-500 mb-8 text-sm leading-relaxed">
          {isSuccess ? (
            <>
              You have successfully enrolled in <br />
              <span className="font-bold text-gray-900 text-base">
                {courseName || 'the session'}
              </span>
              .
            </>
          ) : (
            'There was an issue with your payment. Please try again.'
          )}
        </p>

        {isSuccess && isNewUser && (
          <div className="bg-purple-50 p-4 rounded-xl border border-purple-100 mb-6 text-left">
            <h4 className="font-bold text-exiser-primary text-sm mb-2">Login Credentials Sent! 📧</h4>
            <p className="text-xs text-gray-600 mb-2">
              We have created an account for you. Your <strong>Login ID</strong> and <strong>Password</strong> have been sent to your email.
            </p>
            <p className="text-xs text-gray-500 italic">
              (Please check your Inbox/Spam/Junk folder)
            </p>
          </div>
        )}

        {transactionId && (
          <div className="bg-gray-50 p-4 rounded-xl border border-gray-200 mb-8">
            <p className="text-[10px] font-bold uppercase text-gray-400 mb-2 tracking-widest">
              Transaction ID
            </p>
            <span className="text-lg font-mono font-bold text-gray-800 tracking-wide select-all">
              {transactionId}
            </span>
          </div>
        )}

        {isSuccess && (
          <div className="flex flex-col gap-3 w-full">
            <Link
              to="/customer-login"
              className="w-full bg-exiser-primary text-white font-bold py-3 rounded-lg hover:bg-purple-900 transition-all text-sm uppercase tracking-wider"
            >
              Go to Customer Login
            </Link>
            <Link
              to="/"
              className="text-xs font-bold text-gray-400 hover:text-gray-600"
            >
              Back to Home
            </Link>
          </div>
        )}

        {!isSuccess && (
          <Link
            to="/book-session"
            className="text-sm font-bold text-gray-500 hover:text-exiser-primary transition-colors"
          >
            Try Again
          </Link>
        )}
      </div>
    </div>
  );
};

export default PaymentStatus;
